<template>
    <div>
        <div class="banner connection-bn">
            <img src="@/assets/images/banner11.png" alt="">
            <h2 class="title">Connection｜我們在這...</h2>
        </div>
        <div class="wrap">
            <section id="tabs-block" class="section">
                <ul class="text-center">
                    <li><a href="javascript:;">
                        <div class="name">聯絡<br>我們</div>
                        <p>Connection</p>
                    </a></li>
                </ul>
            </section>
            <section class="section contact-section">
                <form action="">
                    <div class="row">
                        <div class="col col2">
                            <p>◎ 歡迎您填寫以下表單與我們聯絡 ( <span style="color:red;">*</span>為必填欄位 )</p>
                            <div class="input-box">
                                <label><span>*</span>主　　旨：</label>
                                <input v-model.trim="push_title" type="text" placeholder="請輸入主旨">
                            </div>
                            <div class="input-box">
                                <label>公司名稱：</label>
                                <input v-model.trim="company_name" type="text" placeholder="請輸入公司名稱">
                            </div>
                            <div class="input-box">
                                <label><span>*</span>電　　話：</label>
                                <input v-model.trim="user_phone" type="text" placeholder="請輸入電話">
                            </div>
                            <div class="input-box">
                                <label>傳　　真：</label>
                                <input v-model.trim="fax_phone" type="text" placeholder="請輸入傳真">
                            </div>
                            <div class="input-box">
                                <label><span>*</span>聯&nbsp; 絡 &nbsp;人：</label>
                                <input v-model.trim="user_name" type="text" placeholder="請輸入聯絡人姓名">
                            </div>
                            <div class="input-box">
                                <label>地　　址：</label>
                                <input v-model.trim="user_address" type="text" placeholder="請輸入地址">
                            </div>
                            <div class="input-box">
                                <label><span>*</span>郵件信箱：</label>
                                <input v-model.trim="email" type="mail" placeholder="請輸入E-Mail">
                            </div>
                        </div>
                        <div class="col col2">
                            <div class="textarea-box">
                                <label><span style="color:red;">*</span>內容：</label>
                                <textarea  v-model.trim="content"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="btn-block text-center">
                        <button type="button" class="btn btn-br" @click="send(push_title, user_phone, user_name, email, content)">
                            送出資料
                        </button>
                    </div>
                </form>
                <!-- QRcode -->
                <!-- <div class="img text-center">
                    <img src="@/assets/images/line.gif" alt="" width="170">
                </div> -->
            </section>
        </div>
        <div class="room_model_block" v-show="room_model">
            <div class="model_content">
                <div class="model_content_hed">
                    <p class="text-center">
                        主旨:{{push_title}}
                    </p>
                    <p v-show="company_name" class="text-center">
                        公司名稱:{{company_name}}
                    </p>
                    <p class="text-center">
                        電話:{{user_phone}}
                    </p>
                    <p v-show="fax_phone" class="text-center">
                        傳真:{{fax_phone}}
                    </p>
                    <p class="text-center">
                        聯絡人:{{user_name}}
                    </p>
                    <p v-show="user_address" class="text-center">
                        地址:{{user_address}}
                    </p>
                    <p class="text-center">
                        郵件信箱:{{email}}
                    </p>
                </div>
                <div class="model_content_body">
                    <p>
                        {{content}}
                    </p>
                </div>
                <div class="model_content_btn">
                    <button @click="send_push">
                        確定
                    </button>
                    <button @click="room_model = !room_model">
                        取消
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'connection',
    data () {
        return {
            push_title: '',
            company_name: '',
            user_phone: '',
            fax_phone: '',
            user_name: '',
            user_address: '',
            email: '',
            content: '',
            //
            room_model: false
        }
    },
    methods: {
        send (push_title, user_phone, user_name, email, content) {
            if (!push_title) {
                alert('請輸入主旨');
            } else if (!user_phone) {
                alert('請輸入電話');
            } else if (!user_name) {
                alert('請輸入聯絡人');
            } else if (!email) {
                alert('請輸入郵件信箱');
            } else if (!content) {
                alert('請輸入內容');
            } else {
                this.room_model = true;
            }
        },
        send_push () {
            if (!this.push_title || !this.user_phone || !this.user_name || !this.email || !this.content) {
                alert('請輸入必填資訊');
            } else {
                const pushData = new FormData();
                pushData.append('CMD', 'ConnectionCreate');
                pushData.append('title', this.push_title);
                pushData.append('company_name', this.company_name);
                pushData.append('user_phone', this.user_phone);
                pushData.append('fax_phone', this.fax_phone);
                pushData.append('user_name', this.user_name);
                pushData.append('user_address', this.user_address);
                pushData.append('email', this.email);
                pushData.append('content', this.content);
                this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, pushData)
                .then(response => {
                    // console.log(response);
                    if (response.data.result == false) {
                        alert(response.data.error_type);
                    } else {
                        this.room_model = false;
                        Object.assign(this.$data,this.$options.data());
                        alert('送出成功');
                    }
                })
                .catch(error => {
                    console.log(error);
                })
            }
        }
    }
};
</script>

<style>
.room_model_block {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}
.room_model_block .model_content{
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
@media (max-width: 964px) {
    .room_model_block .model_content{
        width: 80% !important;
    }
}
.room_model_block .model_content {
    width: 50%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.room_model_block .model_content .model_content_hed,
.room_model_block .model_content .model_content_body,
.room_model_block .model_content .model_content_btn{
    width: 100%;
    background-color: #fff;
    padding: 10px;
}
.room_model_block .model_content .model_content_body{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.room_model_block .model_content .model_content_body .label_box{
    padding: 20px;
}
.model_content_body .label_box input{
    height: 30px;
    font-size: 25px;
}
.room_model_block .model_content .model_content_btn{
    display: flex;
    justify-content: center;
}
.room_model_block .model_content .model_content_btn button{
    padding: 10px 15px;
    margin: 10px;
    background-color: blue;
    color: #fff;
    font-size: 25px;
    border: unset;
    border-radius: 10px;
    box-shadow: -2px 3px 5px #666;
}
.room_model_block .model_content .model_content_btn button:nth-child(2){
    background-color: red;
}
</style>
